import { Link } from "@tanstack/react-router";

const FOOTER_LINKS = [
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
] as const;

export function PublicFooter() {
  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-6 py-6 text-sm text-muted-foreground">
        <span>© 2026 TodoLLM</span>
        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          {FOOTER_LINKS.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="transition-colors hover:text-foreground"
            >
              {label}
            </Link>
          ))}
          <a
            href="https://stats.uptimerobot.com/m0exbqGCmL"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-foreground"
          >
            Status
          </a>
        </nav>
      </div>
    </footer>
  );
}
